export const PRIMARY_COLOR = "#1976D2";